"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/050/050store/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/Volumes/Untitled/project/050/050store/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _date = require("@/utils/date");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _FoodDialog = _interopRequireDefault(require("./FoodDialog"));
var food = _interopRequireWildcard(require("@/api/food"));
var _format = require("@/utils/format");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default,
    FoodDialog: _FoodDialog.default
  },
  created: function created() {
    this.getTableData();
  },
  data: function data() {
    return {
      listLoading: false,
      total: 0,
      baseUrl: process.env.VUE_APP_BASE_API,
      baseUrlMedia: process.env.VUE_APP_BASE_URL_MEDIA,
      listQuery: {
        page: 1,
        limit: 10,
        search: "",
        isBlock: null
      },
      tableData: []
    };
  },
  methods: {
    formatCurrency: function formatCurrency(n) {
      return (0, _format.formatCurrency)(n);
    },
    handleEdit: function handleEdit(row) {
      this.$refs["dialog"].handleEdit(row);
    },
    handleCommand: function handleCommand(command) {
      if (command.isBlock) {
        this.handleUnBlock(command);
      } else {
        this.handleBlock(command);
      }
    },
    handleAdd: function handleAdd() {
      this.$refs["dialog"].handleAdd();
    },
    handleImgError: function handleImgError(event) {
      event.currentTarget.src = require("@/assets/images/avatar_default.svg");
    },
    handleUnBlock: function handleUnBlock(row) {
      var _this = this;
      this.$confirm("Món ăn này sẽ được mở khóa, bạn có muốn tiếp tục?", "Cảnh báo", {
        confirmButtonText: "OK",
        cancelButtonText: "Đóng",
        type: "warning"
      }).then(function () {
        var data = {
          food: {
            isBlock: false
          }
        };
        food.update(row.id, data).then(function () {
          row.isBlock = false;
          _this.$message({
            type: "success",
            message: "Mở khóa thành công"
          });
        });
      });
    },
    handleBlock: function handleBlock(row) {
      var _this2 = this;
      this.$confirm("Món ăn này sẽ bị khóa, bạn có muốn tiếp tục?", "Cảnh báo", {
        confirmButtonText: "OK",
        cancelButtonText: "Đóng",
        type: "warning"
      }).then(function () {
        var data = {
          food: {
            isBlock: true
          }
        };
        food.update(row.id, data).then(function () {
          row.isBlock = true;
          _this2.$message({
            type: "success",
            message: "Khóa thành công"
          });
        });
      });
    },
    getTableData: function getTableData() {
      var _this3 = this;
      this.listLoading = true;
      food.findAll(this.listQuery).then(function (res) {
        _this3.tableData = res.data.foods;
        _this3.total = res.data.total;
      }).finally(function () {
        _this3.listLoading = false;
      });
    },
    formatDateTime: function formatDateTime(timestamp) {
      return (0, _date.formatDateTime)(timestamp);
    },
    editData: function editData(row) {
      var _this4 = this;
      var data = {
        food: {
          position: row.position
        }
      };
      food.update(row.id, data).then(function (res) {
        _this4.getTableData();
      });
    }
  }
};